 
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetRestaurantAddRequestsDocument = gql`
    query GetRestaurantAddRequests($search: String, $statuses: [RestaurantAddRequestStatus!], $page: Int, $perPage: Int) {
  restaurantAddRequests(
    search: $search
    statuses: $statuses
    page: $page
    perPage: $perPage
  ) {
    requests {
      id
      venueName
      countryName
      city
      address
      contactName
      contactEmail
      contactPhone
      role
      website
      googleMapsUrl
      comment
      internalNote
      status
      createdAt(format: "Y-m-d H:i:s")
      updatedAt(format: "Y-m-d H:i:s")
    }
    totalCount
    currentPage
    itemsPerPage
    pageCount
  }
}
    `;

/**
 * __useGetRestaurantAddRequestsQuery__
 *
 * To run a query within a React component, call `useGetRestaurantAddRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantAddRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantAddRequestsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetRestaurantAddRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetRestaurantAddRequestsQuery, GetRestaurantAddRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantAddRequestsQuery, GetRestaurantAddRequestsQueryVariables>(GetRestaurantAddRequestsDocument, options);
      }
export function useGetRestaurantAddRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantAddRequestsQuery, GetRestaurantAddRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantAddRequestsQuery, GetRestaurantAddRequestsQueryVariables>(GetRestaurantAddRequestsDocument, options);
        }
export function useGetRestaurantAddRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRestaurantAddRequestsQuery, GetRestaurantAddRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRestaurantAddRequestsQuery, GetRestaurantAddRequestsQueryVariables>(GetRestaurantAddRequestsDocument, options);
        }
export type GetRestaurantAddRequestsQueryHookResult = ReturnType<typeof useGetRestaurantAddRequestsQuery>;
export type GetRestaurantAddRequestsLazyQueryHookResult = ReturnType<typeof useGetRestaurantAddRequestsLazyQuery>;
export type GetRestaurantAddRequestsSuspenseQueryHookResult = ReturnType<typeof useGetRestaurantAddRequestsSuspenseQuery>;
export type GetRestaurantAddRequestsQueryResult = Apollo.QueryResult<GetRestaurantAddRequestsQuery, GetRestaurantAddRequestsQueryVariables>;
export const GetRestaurantDeleteRequestsDocument = gql`
    query GetRestaurantDeleteRequests($search: String, $statuses: [RestaurantDeleteRequestStatus!], $page: Int, $perPage: Int) {
  restaurantDeleteRequests(
    search: $search
    statuses: $statuses
    page: $page
    perPage: $perPage
  ) {
    requests {
      id
      venueName
      countryName
      city
      address
      contactName
      contactEmail
      contactPhone
      role
      website
      googleMapsUrl
      reason
      reasonLabel
      comment
      internalNote
      status
      createdAt(format: "Y-m-d H:i:s")
      updatedAt(format: "Y-m-d H:i:s")
    }
    totalCount
    currentPage
    itemsPerPage
    pageCount
  }
}
    `;

/**
 * __useGetRestaurantDeleteRequestsQuery__
 *
 * To run a query within a React component, call `useGetRestaurantDeleteRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantDeleteRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantDeleteRequestsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetRestaurantDeleteRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetRestaurantDeleteRequestsQuery, GetRestaurantDeleteRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantDeleteRequestsQuery, GetRestaurantDeleteRequestsQueryVariables>(GetRestaurantDeleteRequestsDocument, options);
      }
export function useGetRestaurantDeleteRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantDeleteRequestsQuery, GetRestaurantDeleteRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantDeleteRequestsQuery, GetRestaurantDeleteRequestsQueryVariables>(GetRestaurantDeleteRequestsDocument, options);
        }
export function useGetRestaurantDeleteRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRestaurantDeleteRequestsQuery, GetRestaurantDeleteRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRestaurantDeleteRequestsQuery, GetRestaurantDeleteRequestsQueryVariables>(GetRestaurantDeleteRequestsDocument, options);
        }
export type GetRestaurantDeleteRequestsQueryHookResult = ReturnType<typeof useGetRestaurantDeleteRequestsQuery>;
export type GetRestaurantDeleteRequestsLazyQueryHookResult = ReturnType<typeof useGetRestaurantDeleteRequestsLazyQuery>;
export type GetRestaurantDeleteRequestsSuspenseQueryHookResult = ReturnType<typeof useGetRestaurantDeleteRequestsSuspenseQuery>;
export type GetRestaurantDeleteRequestsQueryResult = Apollo.QueryResult<GetRestaurantDeleteRequestsQuery, GetRestaurantDeleteRequestsQueryVariables>;
export const GetRestaurantAddRequestByIdDocument = gql`
    query GetRestaurantAddRequestById($id: Int!) {
  restaurantAddRequest(id: $id) {
    id
    venueName
    countryName
    city
    address
    contactName
    contactEmail
    contactPhone
    role
    website
    googleMapsUrl
    comment
    internalNote
    status
    createdAt(format: "Y-m-d H:i:s")
    updatedAt(format: "Y-m-d H:i:s")
  }
}
    `;

/**
 * __useGetRestaurantAddRequestByIdQuery__
 *
 * To run a query within a React component, call `useGetRestaurantAddRequestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantAddRequestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantAddRequestByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRestaurantAddRequestByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantAddRequestByIdQuery, GetRestaurantAddRequestByIdQueryVariables> & ({ variables: GetRestaurantAddRequestByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantAddRequestByIdQuery, GetRestaurantAddRequestByIdQueryVariables>(GetRestaurantAddRequestByIdDocument, options);
      }
export function useGetRestaurantAddRequestByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantAddRequestByIdQuery, GetRestaurantAddRequestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantAddRequestByIdQuery, GetRestaurantAddRequestByIdQueryVariables>(GetRestaurantAddRequestByIdDocument, options);
        }
export function useGetRestaurantAddRequestByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRestaurantAddRequestByIdQuery, GetRestaurantAddRequestByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRestaurantAddRequestByIdQuery, GetRestaurantAddRequestByIdQueryVariables>(GetRestaurantAddRequestByIdDocument, options);
        }
export type GetRestaurantAddRequestByIdQueryHookResult = ReturnType<typeof useGetRestaurantAddRequestByIdQuery>;
export type GetRestaurantAddRequestByIdLazyQueryHookResult = ReturnType<typeof useGetRestaurantAddRequestByIdLazyQuery>;
export type GetRestaurantAddRequestByIdSuspenseQueryHookResult = ReturnType<typeof useGetRestaurantAddRequestByIdSuspenseQuery>;
export type GetRestaurantAddRequestByIdQueryResult = Apollo.QueryResult<GetRestaurantAddRequestByIdQuery, GetRestaurantAddRequestByIdQueryVariables>;
export const GetRestaurantDeleteRequestByIdDocument = gql`
    query GetRestaurantDeleteRequestById($id: Int!) {
  restaurantDeleteRequest(id: $id) {
    id
    venueName
    countryName
    city
    address
    contactName
    contactEmail
    contactPhone
    role
    reason
    reasonLabel
    website
    googleMapsUrl
    comment
    internalNote
    status
    createdAt(format: "Y-m-d H:i:s")
    updatedAt(format: "Y-m-d H:i:s")
  }
}
    `;

/**
 * __useGetRestaurantDeleteRequestByIdQuery__
 *
 * To run a query within a React component, call `useGetRestaurantDeleteRequestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantDeleteRequestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantDeleteRequestByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRestaurantDeleteRequestByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantDeleteRequestByIdQuery, GetRestaurantDeleteRequestByIdQueryVariables> & ({ variables: GetRestaurantDeleteRequestByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantDeleteRequestByIdQuery, GetRestaurantDeleteRequestByIdQueryVariables>(GetRestaurantDeleteRequestByIdDocument, options);
      }
export function useGetRestaurantDeleteRequestByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantDeleteRequestByIdQuery, GetRestaurantDeleteRequestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantDeleteRequestByIdQuery, GetRestaurantDeleteRequestByIdQueryVariables>(GetRestaurantDeleteRequestByIdDocument, options);
        }
export function useGetRestaurantDeleteRequestByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRestaurantDeleteRequestByIdQuery, GetRestaurantDeleteRequestByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRestaurantDeleteRequestByIdQuery, GetRestaurantDeleteRequestByIdQueryVariables>(GetRestaurantDeleteRequestByIdDocument, options);
        }
export type GetRestaurantDeleteRequestByIdQueryHookResult = ReturnType<typeof useGetRestaurantDeleteRequestByIdQuery>;
export type GetRestaurantDeleteRequestByIdLazyQueryHookResult = ReturnType<typeof useGetRestaurantDeleteRequestByIdLazyQuery>;
export type GetRestaurantDeleteRequestByIdSuspenseQueryHookResult = ReturnType<typeof useGetRestaurantDeleteRequestByIdSuspenseQuery>;
export type GetRestaurantDeleteRequestByIdQueryResult = Apollo.QueryResult<GetRestaurantDeleteRequestByIdQuery, GetRestaurantDeleteRequestByIdQueryVariables>;
export const RestaurantAddRequestChangeStatusDocument = gql`
    mutation RestaurantAddRequestChangeStatus($id: Int!, $status: RestaurantAddRequestStatus!) {
  restaurantAddRequestChangeStatus(id: $id, status: $status) {
    id
    status
    internalNote
    updatedAt(format: "Y-m-d H:i:s")
  }
}
    `;
export type RestaurantAddRequestChangeStatusMutationFn = Apollo.MutationFunction<RestaurantAddRequestChangeStatusMutation, RestaurantAddRequestChangeStatusMutationVariables>;

/**
 * __useRestaurantAddRequestChangeStatusMutation__
 *
 * To run a mutation, you first call `useRestaurantAddRequestChangeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestaurantAddRequestChangeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restaurantAddRequestChangeStatusMutation, { data, loading, error }] = useRestaurantAddRequestChangeStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useRestaurantAddRequestChangeStatusMutation(baseOptions?: Apollo.MutationHookOptions<RestaurantAddRequestChangeStatusMutation, RestaurantAddRequestChangeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestaurantAddRequestChangeStatusMutation, RestaurantAddRequestChangeStatusMutationVariables>(RestaurantAddRequestChangeStatusDocument, options);
      }
export type RestaurantAddRequestChangeStatusMutationHookResult = ReturnType<typeof useRestaurantAddRequestChangeStatusMutation>;
export type RestaurantAddRequestChangeStatusMutationResult = Apollo.MutationResult<RestaurantAddRequestChangeStatusMutation>;
export type RestaurantAddRequestChangeStatusMutationOptions = Apollo.BaseMutationOptions<RestaurantAddRequestChangeStatusMutation, RestaurantAddRequestChangeStatusMutationVariables>;
export const RestaurantDeleteRequestChangeStatusDocument = gql`
    mutation RestaurantDeleteRequestChangeStatus($id: Int!, $status: RestaurantDeleteRequestStatus!) {
  restaurantDeleteRequestChangeStatus(id: $id, status: $status) {
    id
    status
    internalNote
    updatedAt(format: "Y-m-d H:i:s")
  }
}
    `;
export type RestaurantDeleteRequestChangeStatusMutationFn = Apollo.MutationFunction<RestaurantDeleteRequestChangeStatusMutation, RestaurantDeleteRequestChangeStatusMutationVariables>;

/**
 * __useRestaurantDeleteRequestChangeStatusMutation__
 *
 * To run a mutation, you first call `useRestaurantDeleteRequestChangeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestaurantDeleteRequestChangeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restaurantDeleteRequestChangeStatusMutation, { data, loading, error }] = useRestaurantDeleteRequestChangeStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useRestaurantDeleteRequestChangeStatusMutation(baseOptions?: Apollo.MutationHookOptions<RestaurantDeleteRequestChangeStatusMutation, RestaurantDeleteRequestChangeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestaurantDeleteRequestChangeStatusMutation, RestaurantDeleteRequestChangeStatusMutationVariables>(RestaurantDeleteRequestChangeStatusDocument, options);
      }
export type RestaurantDeleteRequestChangeStatusMutationHookResult = ReturnType<typeof useRestaurantDeleteRequestChangeStatusMutation>;
export type RestaurantDeleteRequestChangeStatusMutationResult = Apollo.MutationResult<RestaurantDeleteRequestChangeStatusMutation>;
export type RestaurantDeleteRequestChangeStatusMutationOptions = Apollo.BaseMutationOptions<RestaurantDeleteRequestChangeStatusMutation, RestaurantDeleteRequestChangeStatusMutationVariables>;
export const RestaurantAddRequestSetInternalNoteDocument = gql`
    mutation RestaurantAddRequestSetInternalNote($id: Int!, $internalNote: String) {
  restaurantAddRequestSetInternalNote(id: $id, internalNote: $internalNote) {
    id
    internalNote
  }
}
    `;
export type RestaurantAddRequestSetInternalNoteMutationFn = Apollo.MutationFunction<RestaurantAddRequestSetInternalNoteMutation, RestaurantAddRequestSetInternalNoteMutationVariables>;

/**
 * __useRestaurantAddRequestSetInternalNoteMutation__
 *
 * To run a mutation, you first call `useRestaurantAddRequestSetInternalNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestaurantAddRequestSetInternalNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restaurantAddRequestSetInternalNoteMutation, { data, loading, error }] = useRestaurantAddRequestSetInternalNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      internalNote: // value for 'internalNote'
 *   },
 * });
 */
export function useRestaurantAddRequestSetInternalNoteMutation(baseOptions?: Apollo.MutationHookOptions<RestaurantAddRequestSetInternalNoteMutation, RestaurantAddRequestSetInternalNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestaurantAddRequestSetInternalNoteMutation, RestaurantAddRequestSetInternalNoteMutationVariables>(RestaurantAddRequestSetInternalNoteDocument, options);
      }
export type RestaurantAddRequestSetInternalNoteMutationHookResult = ReturnType<typeof useRestaurantAddRequestSetInternalNoteMutation>;
export type RestaurantAddRequestSetInternalNoteMutationResult = Apollo.MutationResult<RestaurantAddRequestSetInternalNoteMutation>;
export type RestaurantAddRequestSetInternalNoteMutationOptions = Apollo.BaseMutationOptions<RestaurantAddRequestSetInternalNoteMutation, RestaurantAddRequestSetInternalNoteMutationVariables>;
export const RestaurantDeleteRequestSetInternalNoteDocument = gql`
    mutation RestaurantDeleteRequestSetInternalNote($id: Int!, $internalNote: String) {
  restaurantDeleteRequestSetInternalNote(id: $id, internalNote: $internalNote) {
    id
    internalNote
  }
}
    `;
export type RestaurantDeleteRequestSetInternalNoteMutationFn = Apollo.MutationFunction<RestaurantDeleteRequestSetInternalNoteMutation, RestaurantDeleteRequestSetInternalNoteMutationVariables>;

/**
 * __useRestaurantDeleteRequestSetInternalNoteMutation__
 *
 * To run a mutation, you first call `useRestaurantDeleteRequestSetInternalNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestaurantDeleteRequestSetInternalNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restaurantDeleteRequestSetInternalNoteMutation, { data, loading, error }] = useRestaurantDeleteRequestSetInternalNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      internalNote: // value for 'internalNote'
 *   },
 * });
 */
export function useRestaurantDeleteRequestSetInternalNoteMutation(baseOptions?: Apollo.MutationHookOptions<RestaurantDeleteRequestSetInternalNoteMutation, RestaurantDeleteRequestSetInternalNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestaurantDeleteRequestSetInternalNoteMutation, RestaurantDeleteRequestSetInternalNoteMutationVariables>(RestaurantDeleteRequestSetInternalNoteDocument, options);
      }
export type RestaurantDeleteRequestSetInternalNoteMutationHookResult = ReturnType<typeof useRestaurantDeleteRequestSetInternalNoteMutation>;
export type RestaurantDeleteRequestSetInternalNoteMutationResult = Apollo.MutationResult<RestaurantDeleteRequestSetInternalNoteMutation>;
export type RestaurantDeleteRequestSetInternalNoteMutationOptions = Apollo.BaseMutationOptions<RestaurantDeleteRequestSetInternalNoteMutation, RestaurantDeleteRequestSetInternalNoteMutationVariables>;
export type GetRestaurantAddRequestsQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  statuses?: Types.InputMaybe<Array<Types.RestaurantAddRequestStatus> | Types.RestaurantAddRequestStatus>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetRestaurantAddRequestsQuery = { __typename?: 'bookingRestaurantQuery', restaurantAddRequests?: { __typename?: 'RestaurantAddRequestPaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, requests?: Array<{ __typename?: 'RestaurantAddRequestProxy', id: number, venueName: string, countryName?: string | null, city: string, address: string, contactName: string, contactEmail: string, contactPhone: string, role?: string | null, website?: string | null, googleMapsUrl?: string | null, comment?: string | null, internalNote?: string | null, status: Types.RestaurantAddRequestStatus, createdAt: string, updatedAt: string }> | null } | null };

export type GetRestaurantDeleteRequestsQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  statuses?: Types.InputMaybe<Array<Types.RestaurantDeleteRequestStatus> | Types.RestaurantDeleteRequestStatus>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetRestaurantDeleteRequestsQuery = { __typename?: 'bookingRestaurantQuery', restaurantDeleteRequests?: { __typename?: 'RestaurantDeleteRequestPaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, requests?: Array<{ __typename?: 'RestaurantDeleteRequestProxy', id: number, venueName: string, countryName?: string | null, city: string, address: string, contactName: string, contactEmail: string, contactPhone: string, role?: string | null, website?: string | null, googleMapsUrl?: string | null, reason: Types.RestaurantDeleteReason, reasonLabel: string, comment?: string | null, internalNote?: string | null, status: Types.RestaurantDeleteRequestStatus, createdAt: string, updatedAt: string }> | null } | null };

export type GetRestaurantAddRequestByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GetRestaurantAddRequestByIdQuery = { __typename?: 'bookingRestaurantQuery', restaurantAddRequest?: { __typename?: 'RestaurantAddRequestProxy', id: number, venueName: string, countryName?: string | null, city: string, address: string, contactName: string, contactEmail: string, contactPhone: string, role?: string | null, website?: string | null, googleMapsUrl?: string | null, comment?: string | null, internalNote?: string | null, status: Types.RestaurantAddRequestStatus, createdAt: string, updatedAt: string } | null };

export type GetRestaurantDeleteRequestByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GetRestaurantDeleteRequestByIdQuery = { __typename?: 'bookingRestaurantQuery', restaurantDeleteRequest?: { __typename?: 'RestaurantDeleteRequestProxy', id: number, venueName: string, countryName?: string | null, city: string, address: string, contactName: string, contactEmail: string, contactPhone: string, role?: string | null, reason: Types.RestaurantDeleteReason, reasonLabel: string, website?: string | null, googleMapsUrl?: string | null, comment?: string | null, internalNote?: string | null, status: Types.RestaurantDeleteRequestStatus, createdAt: string, updatedAt: string } | null };

export type RestaurantAddRequestChangeStatusMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  status: Types.RestaurantAddRequestStatus;
}>;


export type RestaurantAddRequestChangeStatusMutation = { __typename?: 'bookingRestaurantMutation', restaurantAddRequestChangeStatus: { __typename?: 'RestaurantAddRequestProxy', id: number, status: Types.RestaurantAddRequestStatus, internalNote?: string | null, updatedAt: string } };

export type RestaurantDeleteRequestChangeStatusMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  status: Types.RestaurantDeleteRequestStatus;
}>;


export type RestaurantDeleteRequestChangeStatusMutation = { __typename?: 'bookingRestaurantMutation', restaurantDeleteRequestChangeStatus: { __typename?: 'RestaurantDeleteRequestProxy', id: number, status: Types.RestaurantDeleteRequestStatus, internalNote?: string | null, updatedAt: string } };

export type RestaurantAddRequestSetInternalNoteMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  internalNote?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type RestaurantAddRequestSetInternalNoteMutation = { __typename?: 'bookingRestaurantMutation', restaurantAddRequestSetInternalNote: { __typename?: 'RestaurantAddRequestProxy', id: number, internalNote?: string | null } };

export type RestaurantDeleteRequestSetInternalNoteMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  internalNote?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type RestaurantDeleteRequestSetInternalNoteMutation = { __typename?: 'bookingRestaurantMutation', restaurantDeleteRequestSetInternalNote: { __typename?: 'RestaurantDeleteRequestProxy', id: number, internalNote?: string | null } };
